import { useEffect, useState } from 'react';
import { fetchAdminData } from '../api';

const AdminDashboard = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [adminData, setAdminData] = useState(null);

  useEffect(() => {
    const data = fetchAdminData().then((data) => {
      console.log(data);
      setAdminData(data);
      setIsLoading(false);
    });
  }, []);

  if (isLoading) {
    return (
      <div>Loading...</div>
    );
  } else {
    return (
      <div className="admin-page">
        <div className="admin-section">
          <div className="admin-heading">Player Data</div>
          <div className="admin-data-row">
            <div className="admin-data-label">Total Players</div>
            <div className="admin-data-value">{adminData.playerData.totalPlayerCount}</div>
          </div>
          <div className="admin-data-row">
            <div className="admin-data-label">Registered Players</div>
            <div className="admin-data-value">{adminData.playerData.totalRegisteredPlayerCount}</div>
          </div>
          <div className="admin-data-row">
            <div className="admin-data-label">New This Month</div>
            <div className="admin-data-value">{adminData.playerData.newPlayersThisMonthCount}</div>
          </div>
          <div className="admin-data-row">
            <div className="admin-data-label">New This Week</div>
            <div className="admin-data-value">{adminData.playerData.newPlayersThisWeekCount}</div>
          </div>
          <div className="admin-data-row">
            <div className="admin-data-label">New Today</div>
            <div className="admin-data-value">{adminData.playerData.newPlayersTodayCount}</div>
          </div>
          <div className="admin-data-row">
            <div className="admin-data-label">Active Today</div>
            <div className="admin-data-value">{adminData.playerData.activePlayersTodayCount}</div>
          </div>
        </div>
        <div className="admin-section">
          <div className="admin-heading">Subject Data</div>
          <div className="admin-data-row">
            <div className="admin-data-label">Total Subjects</div>
            <div className="admin-data-value">{adminData.subjectData.totalSubjectCount}</div>
          </div>
          <div className="admin-data-row">
            <div className="admin-data-label">New This Month</div>
            <div className="admin-data-value">{adminData.subjectData.newSubjectsThisMonthCount}</div>
          </div>
          <div className="admin-data-row">
            <div className="admin-data-label">New This Week</div>
            <div className="admin-data-value">{adminData.subjectData.newSubjectsThisWeekCount}</div>
          </div>
          <div className="admin-data-row">
            <div className="admin-data-label">New Today</div>
            <div className="admin-data-value">{adminData.subjectData.newSubjectsTodayCount}</div>
          </div>
          <div className="admin-data-row">
            <div className="admin-data-label">Unvetted Subjects</div>
            <div className="admin-data-value">{adminData.subjectData.unvettedSubjectCount}</div>
          </div>
        </div>
        <div className="admin-section">
          <div className="admin-heading">Question Data</div>
          <div className="admin-data-row">
            <div className="admin-data-label">Total Questions</div>
            <div className="admin-data-value">{adminData.questionData.totalQuestionCount}</div>
          </div>
          <div className="admin-data-row">
            <div className="admin-data-label">New This Month</div>
            <div className="admin-data-value">{adminData.questionData.newQuestionsThisMonthCount}</div>
          </div>
          <div className="admin-data-row">
            <div className="admin-data-label">New This Week</div>
            <div className="admin-data-value">{adminData.questionData.newQuestionsThisWeekCount}</div>
          </div>
          <div className="admin-data-row">
            <div className="admin-data-label">New Today</div>
            <div className="admin-data-value">{adminData.questionData.newQuestionsTodayCount}</div>
          </div>
          <div className="admin-data-row">
            <div className="admin-data-label">Flagged Questions</div>
            <div className="admin-data-value">{adminData.questionData.flaggedQuestionCount}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default AdminDashboard;
